import React, { useEffect, useState } from 'react';
import * as Page from 'HOC/Layout/PageContainer';
import styles from './index.module.css';
import { Card, Input, Button, message } from 'antd';
import { connect } from 'react-redux';
import { updateSettings } from 'store/actions/setting';

const { Container, Title } = Page;

const SettingPage = ({ settings, updateSettings }) => {
  const [state, setState] = useState({
    gst: 0,
  });

  useEffect(() => {
    if (!settings) {
      return;
    }

    setState({
      ...settings,
    });
  }, [settings]);

  const handleChangeGST = e => {
    let gst = e.target.value;
    setState({ ...state, gst });
  };

  const handleUpdateSetting = () => {
    let gst = parseFloat(state.gst);
    if (isNaN(gst)) {
      return;
    }

    updateSettings({ ...state, gst: gst }, () => {
      message.success('Updated settings');
    });
  };

  return (
    <Container type="2x3">
      <Title title="Settings" />
      <div className={styles.Main}>
        <Card
          title={
            <div className={styles.CardTitle}>
              <span>Update Settings</span>
            </div>
          }
        >
          <div className={styles.CardContent}>
            <label htmlFor="gst" style={{ whiteSpace: 'nowrap' }}>
              GST (%)
            </label>
            <Input name="gst" placeholder="GST" value={state.gst} onChange={handleChangeGST} />
          </div>
          <div className={styles.CardContent}>
            <Button type="primary" onClick={handleUpdateSetting}>
              Apply
            </Button>
          </div>
        </Card>
      </div>
    </Container>
  );
};

const mapStateToProps = state => {
  return {
    settings: state.setting.settings,
  };
};

const mapDispatchToProps = {
  updateSettings: updateSettings,
};

export default connect(mapStateToProps, mapDispatchToProps)(SettingPage);



// WEBPACK FOOTER //
// ./src/containers/Setting/index.js